import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=9d0e5e5a&scoped=true&"
import script from "./DescriptionCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCard.vue?vue&type=style&index=0&id=9d0e5e5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0e5e5a",
  null
  
)

export default component.exports